import { render } from "./StartPageLayout.vue?vue&type=template&id=0fa59194&scoped=true"
import script from "./StartPageLayout.vue?vue&type=script&lang=js"
export * from "./StartPageLayout.vue?vue&type=script&lang=js"

import "./StartPageLayout.vue?vue&type=style&index=0&id=0fa59194&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa59194"]])

export default __exports__